document.addEventListener('DOMContentLoaded', function () {

  /* ---- Swatch-style variant picker ----
     Swatches carry data-swatch-value. Selecting one updates a hidden
     native <select> for that option so Shopify's variant logic (and the
     cart form) keeps working with zero extra dependencies. */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var selects = picker.querySelectorAll('select[data-option-select]');
    var swatchGroups = picker.querySelectorAll('[data-swatch-group]');
    var priceEl = picker.querySelector('[data-product-price]');
    var comparePriceEl = picker.querySelector('[data-product-compare-price]');
    var addBtn = picker.querySelector('[data-add-to-cart]');
    var variantIdInput = picker.querySelector('[data-variant-id]');
    var variants = JSON.parse(picker.getAttribute('data-variants') || '[]');

    function currentSelection() {
      var values = [];
      selects.forEach(function (s) { values.push(s.value); });
      return values;
    }

    function findMatchingVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === sel[i]; });
      });
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var match = findMatchingVariant();
      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        return;
      }
      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (comparePriceEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          comparePriceEl.textContent = formatMoney(match.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (addBtn) {
        if (!match.available) {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to bag — ' + formatMoney(match.price);
        }
      }
    }

    swatchGroups.forEach(function (group) {
      var optionIndex = group.getAttribute('data-swatch-group');
      var select = picker.querySelector('select[data-option-select="' + optionIndex + '"]');
      group.querySelectorAll('[data-swatch-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-swatch-value]').forEach(function (b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');
          if (select) {
            select.value = btn.getAttribute('data-swatch-value');
          }
          updateUI();
        });
      });
    });

    updateUI();
  });

  /* ---- Quantity stepper ---- */
  document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    stepper.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-qty-step'), 10);
        var current = parseInt(input.value, 10) || 1;
        var next = Math.max(1, current + dir);
        input.value = next;
        input.dispatchEvent(new Event('change'));
      });
    });
  });

  /* ---- Cart line quantity auto-submit ---- */
  document.querySelectorAll('[data-cart-qty-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

});
